import BasePage from "pages/base_page";
import currentRegion from "lib/currentRegion";
import renderEditorialMenu from "lib/renderEditorialMenu";

const EDITORIAL_ACTIONS_MENU_PATH = "/editorial/actions_menu/team?regionCode=:region:";

export default class TeamPage extends BasePage {
  initialize(options) {
    super.initialize(options);

    currentRegion()
      .then((regionCode) => {
        renderEditorialMenu(EDITORIAL_ACTIONS_MENU_PATH.replace(":region:", regionCode));
      });
  }
}
